const modelDetails = [{
  key: 'textures',
  labelKey: 'textures',
}, {
  key: 'materials',
  labelKey: 'materials',
}, {
  key: 'uvwMapping',
  labelKey: 'uvw_mapping',
}, {
  key: 'pluginsUsed',
  labelKey: 'plugins_used',
}]

export default modelDetails
